<template>
    <div class="main-box" v-loading="loading">
        <NavBar title="职位详情"></NavBar>
        <div class="container" v-if="!empty">
            <div class="header">
                <div class="title" v-html="post.postName"></div>
                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>
                <div class="subtitle">
                    <span class="item" v-if="post.org" v-html="'招聘公司：' + post.org.orgName"></span>
                    <span class="item" v-if="post.postType" v-html="'岗位类型：' + post.postType.postTypeName"></span>
                </div>
                <div class="subtitle" v-if="post.area && post.area.areaName" v-html="'工作地点：' + post.area.areaName"></div>
                <div class="subtitle" v-if="post.demandNumber" v-html="'招聘人数：' + post.demandNumber + '人'"></div>
            </div>
            <div class="body">
                <div class="title" v-if="post.duty.length !== 0">工作职责：</div>
                <p class="detailed" v-for="text of post.duty" :key="text" v-html="text"></p>
                <div class="title" v-if="post.requirement.length !== 0">任职要求：</div>
                <p class="detailed" v-for="text of post.requirement" :key="text" v-html="text"></p>
            </div>
        </div>
        <div class="footer" v-if="!empty">
            <el-button type="primary" style="width:100%" @click="notifyConfirmOpen">申请岗位</el-button>
        </div>
        <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！" v-if="empty">
            <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
        </el-empty>
        <van-dialog v-model="notifyConfirmShow" title="候选人告知书" show-cancel-button confirmButtonText="我已阅读上述内容" @confirm="applyPost">
          <div style="height: 350px;overflow: auto;line-height: 1.5;padding: 0 6px;">
            <div style="padding-top: 10px;">亲爱的候选人您好，请在确认申请职位之前，务必认真阅读并透彻理解以下隐私政策条款，一旦您确认提交，即表示您已充分理解并同意以下条款。</div>
            <div style="padding-top: 10px;">1）您通过本招聘平台求职时，可上传您的简历并表达您对职位的求职意向。我们会收集您的以下信息：姓名、性别、年龄、出生日期、证件号码、现居住地、户籍所在地、民族、政治面貌、教育背景、手机号码和邮箱、工作经历、项目经历、照片信息、紧急联系人（您应保证向我们提供紧急联系人信息之前已经就此取得了该紧急联系人的同意）的联系方式等敏感信息，以及您主动提供的其他信息（包括内推信息等）。</div>
            <div style="padding-top: 10px;">2）我们收集上述信息仅用于员工招聘，我们会使用您提交的简历信息进行相关的人员甄选和招聘活动，在这个过程中我们的HR或者面试官可能会与您进行电话沟通以便进行面试邀约或者进行其他招聘活动过程中所必要的沟通和交流。我们将会在本条款所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了于收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</div>
            <div style="padding-top: 10px;">3）一般而言，我们仅会为实现员工招聘目的所必需的最短时间保留您的个人信息，超出上述期限后，我们将删除您的个人信息或对您的个人信息进行匿名化处理。</div>
            <div style="padding-top: 10px;">4）本招聘平台系璞泰来集团名下多家子公司及关联公司共同使用，我们可将您基于求职目的而提交的信息与璞泰来集团及子公司和关联公司共享，共享用途亦仅用于员工招聘。</div>
          </div>
        </van-dialog>
    </div>
</template>
<script>
import NavBar from './components/NavBar.vue';
import api from '@/api';
export default {
    name: 'MCampus',
    components: { NavBar },
    data() {
        return {
            empty: false,
            showTotal: true,
            loading: false,
            post: { duty: [], requirement: [] },
            hiddenAll: false,
            notifyConfirmShow: false
        };
    },
    watch: {
        $route: (to, from) => {
            // console.log(to);
            // console.log(from);
        }
    },
    created() {
        this.getDetailByPostId(this.$route.params.id);
    },
    mounted() {
    },
    methods: {
        notifyConfirmOpen() {
            this.notifyConfirmShow = true;
        },
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty ? res.data.duty.split(/[(\r\n)\r\n]+/) : [];
            res.data.requirement = res.data.requirement ? res.data.requirement.split(/[(\r\n)\r\n]+/) : [];
            this.post = res.data;
        },
        // 申请岗位
        applyPost() {
            let url = '/m/post/' + this.$route.params.id + '/apply';
            if (this.$store.state.promoterId) {
                url += '?promoterId=' + this.$store.state.promoterId;
            }
            this.$router.push(url);
        },
        // 查看更多岗位点击
        otherPostClick() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    .container {
        width: 100%;
        overflow: auto;
        position: absolute;
        top: 56px;
        bottom: 61px;
        box-sizing: border-box;
        padding: 15px 20px 20px 20px;
        background: #fff;
        .header {
            padding-bottom: 5px;
            border-bottom: 3px solid #eee;
            .title {
                line-height: 24px;
                font-size: 20px;
                color: #222831;
                margin-bottom: 8px;
                font-weight: 600;
            }
            .subtitle {
                font-size: 14px;
                color: #89909e;
                font-weight: 400;
                margin: 5px 0;
                .item {
                    padding: 0 10px;
                    border-right: 1px solid #dddfe3;
                }
                .item:first-child {
                    padding-left: 0;
                }
                .item:last-child {
                    border-right: none;
                }
            }
            .salary {
                color: #ff6b6b;
                font-size: 18px;
                line-height: 20px;
                margin-bottom: 5px;
                font-weight: 600;
            }
        }
        .body {
            .title {
                margin-top: 15px;
                margin-bottom: 9px;
                font-size: 16px;
                color: #222831;
            }

            .detailed {
                color: #a2a4a8;
                font-size: 14px;
                white-space: pre-wrap;
                margin: 0;
            }
        }
    }
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        box-sizing: border-box;
        background: #fff;
        border-top: 1px solid #eee;
        padding: 10px 20px;
    }
}
</style>
